import { render, staticRenderFns } from "./sendRange.vue?vue&type=template&id=057d7ea8&scoped=true&"
import script from "./sendRange.vue?vue&type=script&lang=js&"
export * from "./sendRange.vue?vue&type=script&lang=js&"
import style0 from "./sendRange.vue?vue&type=style&index=0&id=057d7ea8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057d7ea8",
  null
  
)

export default component.exports